import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import { PaginatedResult } from "services/@types";
import apiInputService from "services/apiInputService";
import { Sow } from "./@types";

const fetchGetSOWsByIdSowOperative = async (
  fieldglassId: string
): Promise<PaginatedResult<Sow>> => {
  const sows = await apiInputService.get(
    `/frontend/sow/admin/operative/${fieldglassId}`
  );
  const { data } = sows;

  return data as PaginatedResult<Sow>;
};

export const useGetSOWsByIdSowOperativeQuery = (
  params?: string,
  options?: any
) => {
  const { subscription } = useSubscription();

  return useQuery<any>(
    ["sowAdmById", subscription?.subscriptionId, params],
    () => fetchGetSOWsByIdSowOperative(params),
    {
      keepPreviousData: true,
      ...options,
    }
  );
};
